
    import '/opt/buildhome/repo/packages/x/CHANGELOG.en-US.md?watch=parent';
    export const demoIndex = {
  ids: [],
  getter: () => import(/* webpackChunkName: "meta__CHANGELOG.en-US.md__en-US" */'/opt/buildhome/repo/packages/x/CHANGELOG.en-US.md?type=demo')
};